import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import moment from "moment"

import * as complaintApis from "../../utilities/apis/complaint"
import { getComplaintStatus } from "../../utilities/enumerations/constants"
import * as functions from "../../utilities/enumerations/functions"

export default function Complaint({ customer }) {
  const { token, permissions } = useSelector(state => state.user)
  const [complaints, setComplaints] = useState([])

  const getComplaints = async (params) => {
    try {
      const response = await complaintApis.getComplaints(token, functions.paramsToQuery(params))
      if (!response.status) throw new Error(response.message)

      setComplaints(response.complaints)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    if (customer) getComplaints({ customer_id: customer.id })
    else setComplaints([])
  }, [customer])

  return (
    <div className="border rounded-4">
      <div className="p-3 border-bottom rounded-top-4">
        <p className="text-body-emphasis fw-bold m-0">Recent Complaint</p>
      </div>
      <table className="table table-filter shadow-none m-0">
        <thead className="table-light">
          <tr>
            <th scope="col" style={{ width: "15%" }} className="align-middle">Name</th>
            <th scope="col" style={{ width: "15%" }} className="align-middle">Mobile</th>
            <th scope="col" style={{ width: "40%" }} className="align-middle">Message</th>
            <th scope="col" style={{ width: "15%" }} className="align-middle text-center">Status</th>
            <th scope="col" style={{ width: "15%" }} className="align-middle">Datetime</th>
            <th scope="col" style={{ width: "12%" }} className="align-middle text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {complaints.map((row) => (
            <tr key={row.id.toString()}>
              <td className="align-middle">{row.name || "N/A"}</td>
              <td className="align-middle">{row.customer.mobile}</td>
              <td className="align-middle">{row.message}</td>
              <td className="align-middle text-center">{getComplaintStatus[row.status]}</td>
              <td className="align-middle">{moment(row.created_at).format('DD MMMM YYYY HH:mm')}</td>
              <td className="align-middle text-center">
                {(permissions["READ_COMPLAINT"]) && (<Link className="me-2" to={`/dashboard/complaint?id=${row.id}`} target="_blank"><i className="far fa-clipboard"></i></Link>)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
